<template>
  <section class="container mx-auto pt-6 md:pt-15 md:w-full">
    <h2 class="section-heading">Articles</h2>

    <NuxtLink
      :to="`/ideas/${contentsData?.[0]?.attributes?.slug}`"
      :title="contentsData?.[0]?.attributes?.card_title"
      class="highlight flex flex-col md:flex-row gap-x-11 gap-y-4 mt-8 md:mt-12"
    >
      <div class="w-full md:w-1/2 overflow-hidden rounded-lg">
        <NuxtImg
          format="webp"
          srcset=""
          loading="lazy"
          :src="
            contentsData?.[0]?.attributes?.image?.data?.attributes?.url ||
            '/assets/img/404.png'
          "
          :alt="contentsData?.[0]?.attributes?.card_title"
          :title="contentsData?.[0]?.attributes?.card_title"
          class="w-full rounded-lg highlight-image duration-200"
        />
      </div>
      <div class="w-full md:w-1/2 flex flex-col justify-center gap-2 md:gap-8">
        <h3
          class="text-lg md:text-4xl leading-normal font-medium hover:text-primary-primary w-full lg:w-4/5 cursor-pointer text-bw-900"
        >
          {{ contentsData?.[0]?.attributes?.card_title }}
        </h3>
        <p class="text-sm sm:text-base text-bw-800 w-full lg:w-2/3">
          {{
            contentsData?.[0]?.attributes?.layout_component?.[0]?.description
          }}
        </p>
      </div>
    </NuxtLink>

    <div
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-8 md:gap-y-12 py-8 md:py-10"
    >
      <template v-if="isLoading">
        <div v-for="i in 6" :key="i" class="flex flex-col gap-4">
          <UtilsSkeletonLoading class="h-44" />
          <UtilsSkeletonLoading class="h-10" />
        </div>
      </template>
      <template v-else>
        <ArticleCard
          v-for="content in contentsData.slice(1)"
          :key="content.id"
          :with-logo="false"
          :title="content?.attributes?.card_title"
          :desc="content?.attributes?.layout_component?.[0]?.description"
          :image-url="
            content?.attributes?.image.data !== null
              ? content?.attributes?.image?.data?.attributes?.url
              : '/assets/img/404.png'
          "
          :slug="`/ideas/${content?.attributes?.slug}`"
        />
      </template>
    </div>

    <div class="mx-auto text-center">
      <CommonViewAllButton url="/ideas" page-name="Articles" />
    </div>
  </section>
</template>

<script setup>
const isLoading = ref(true)
const contentsData = ref([])

const articles = await useSuitmediaApiData(`/api/contents`, {
  query: {
    'pagination[pageSize]': 9,
    populate: 'image,layout_component,layout_component.type',
    'filters[$and][0][layout][$eq]': 'article',
    'sort[0]': 'publish_at:desc',
    'sort[1]': 'id:desc'
  }
})

isLoading.value = articles.pending.value

if (articles.error.value) {
  throw createError({
    statusCode: 404,
    message: `Articles does not exist`
  })
}

contentsData.value = articles.data.value.data
</script>

<style lang="scss" scoped>
.highlight-image {
  &:hover {
    transform: scale(1.2);
  }
}
</style>
